export default "__VITE_ASSET__kH5LVmcC__"